var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

/**
 * The divider component will pass all other props such as style or
 * event listeners on to the component.
 */

var Divider = function (_PureComponent) {
  _inherits(Divider, _PureComponent);
  function Divider() {
    _classCallCheck(this, Divider);
    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
  }
  Divider.prototype.render = function render() {
    var _props = this.props,
      className = _props.className,
      inset = _props.inset,
      vertical = _props.vertical,
      props = _objectWithoutProperties(_props, ['className', 'inset', 'vertical']);
    var Component = vertical ? 'div' : 'hr';
    return React.createElement(Component, _extends({}, props, {
      className: cn('md-divider', {
        'md-divider--vertical': vertical,
        'md-divider--inset': inset
      }, className)
    }));
  };
  return Divider;
}(PureComponent);
Divider.propTypes = {
  /*
   * An optional style to apply to the divider.
   */
  style: PropTypes.object,
  /**
   * An optional className to apply to the divider.
   */
  className: PropTypes.string,
  /**
   * Boolean if this divider should be inset relative to it's container
   * component. This means that if it is in a `List` with `Avatar`, it
   * will start the divider  to the left of the main text in the list.
   */
  inset: PropTypes.bool,
  /**
   * Boolean if the divider should be vertical instead of horizontal.
   */
  vertical: PropTypes.bool
};
export default Divider;